import { Link } from 'react-router-dom';
import PageHero from '../shared/PageHero.jsx';
import Button from '../shared/Button.jsx';
import Reveal from '../shared/Reveal.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';
import { curriculum, primaryDay } from '../constants/academics.js';

export default function Academics() {
  return (
    <>
      <Seo {...metaFor('/academics')} path="/academics" />

      <PageHero
        eyebrow="Academics"
        title="Fourteen years of teaching, planned as one continuous line."
        lede="Three stages, one campus, and a curriculum written so that the Grade 6 science teacher knows exactly what the Toddler Room did with water and sand."
      />

      <section className="bg-cream pb-10 pt-5">
        <div className="mx-auto grid max-w-[1240px] gap-[22px] px-5 sm:px-8 lg:grid-cols-3">
          {curriculum.map((stage, i) => (
            <Reveal
              key={stage.id}
              index={i}
              as="article"
              className="rounded-[28px] border-[3px] border-forest bg-white p-[26px] shadow-[0_10px_0_rgb(20_83_45_/_0.13)]"
            >
              <p className="flex items-center gap-2.5">
                <span
                  aria-hidden="true"
                  className={`size-3 flex-none rounded-full ${stage.dotClass}`}
                />
                <span
                  className={`text-[12.5px] font-extrabold uppercase tracking-[0.1em] ${stage.eyebrowClass}`}
                >
                  {stage.eyebrow}
                </span>
              </p>
              <h2 className="mt-2 font-display text-[29px] font-extrabold leading-[1.05] text-forest">
                {stage.title}
              </h2>
              <p className="text-sm font-bold text-ink-soft/80">{stage.meta}</p>
              <p className="mt-3 text-[15.5px] leading-[1.55] text-ink-soft">
                {stage.body}
              </p>
              <ul className="mt-4 flex flex-col gap-[7px] text-[14.5px] text-ink-soft">
                {stage.items.map((item) => (
                  <li key={item} className="flex gap-2">
                    <span aria-hidden="true" className="text-sage-mid">
                      ·
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-cream pb-20 pt-11">
        <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
          <Reveal className="rounded-[34px] border-[3px] border-forest bg-white px-6 py-8 shadow-[0_12px_0_rgb(20_83_45_/_0.13)] sm:px-9">
            <h2 className="font-display text-[32px] font-extrabold leading-[1.05] text-forest">
              A day in Primary 3
            </h2>
            <p className="mt-2 max-w-[660px] text-base leading-[1.55] text-ink-soft">
              Not a brochure timetable — this is Tuesday, as it actually runs.
            </p>

            <ol className="mt-5.5 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3">
              {primaryDay.map((slot) => (
                <li key={slot.time} className="rounded-2xl bg-mint/60 px-4 py-3.5">
                  <p className="font-display text-lg font-extrabold text-coral">
                    {slot.time}
                  </p>
                  <p className="mt-0.5 text-[14.5px] text-ink-soft">{slot.what}</p>
                </li>
              ))}
            </ol>

            <div className="mt-6 flex flex-wrap gap-3">
              <Button as={Link} to="/contact" variant="primary" size="md">
                Book a Tuesday visit
              </Button>
              <Button as={Link} to="/facilities" variant="outlineFlat" size="md">
                See the facilities
              </Button>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
